<template>
  <div class="relative">
    <div v-if="showInstallPrompt" class="w-5/6 md:w-3/6 xl:w-1/3 h-auto absolute mx-auto left-0 right-0 z-50 shadow-2xl flex">
      <div class="w-5/6 md:w-3/6 xl:w-1/3 bg-[#181A20] min-h-[9rem] fixed rounded-xl space-y-3 pb-3">
        <p class="text-white text-center pt-3 px-3">{{ installMessage }}</p>
        <div class="w-full relative">
          <div class="flex justify-end px-2 space-x-1">
            <button @click="dismiss" class="px-3 py-2 rounded-md text-white bg-[#FF0000]">{{ $t('ignorerbutton')  }}</button>
            <button v-if="canPromptInstall" @click="install" class="px-3 py-2 rounded-md text-white bg-green-500">{{ $t('telechargerbutton')  }}</button>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      deferredPrompt: null,
      installMode: '',
      showInstallFallback: false
    };
  },
  mounted() {
    this.prepareInstallPrompt()
  },
  created() {
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      if (Cookies.get("add-to-home-screen") === undefined) {
        this.deferredPrompt = e;
        this.installMode = 'prompt'
        this.showInstallFallback = false
      }
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
      this.showInstallFallback = false
    });
  },
  methods: {
    async dismiss() {
      Cookies.set("add-to-home-screen", null, { expires: 7 });
      this.deferredPrompt = null;
      this.showInstallFallback = false
    },
    async install() {
      if (!this.deferredPrompt) return
      this.deferredPrompt.prompt();
      this.deferredPrompt = null
    },
    prepareInstallPrompt() {
      if (Cookies.get("add-to-home-screen") !== undefined || this.isStandalone()) return

      const userAgent = window.navigator.userAgent || ''
      const isIOS = /iphone|ipad|ipod/i.test(userAgent)
      const isSafari = /^((?!chrome|android|crios|fxios|edg|opr).)*safari/i.test(userAgent)
      const isFirefox = /firefox|fxios/i.test(userAgent)

      if (isIOS) {
        this.installMode = 'ios'
        this.showInstallFallback = true
        return
      }

      if (isSafari) {
        this.installMode = 'safari'
        this.showInstallFallback = true
        return
      }

      if (isFirefox) {
        this.installMode = 'firefox'
        this.showInstallFallback = true
      }
    },
    isStandalone() {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
    }
  },
  computed: {
    canPromptInstall() {
      return this.installMode === 'prompt' && this.deferredPrompt
    },
    showInstallPrompt() {
      return this.canPromptInstall || this.showInstallFallback
    },
    installMessage() {
      if (this.installMode === 'ios') return this.$t('installios')
      if (this.installMode === 'safari') return this.$t('installsafari')
      if (this.installMode === 'firefox') return this.$t('installfirefox')
      return this.$t('downloadapp')
    }
  }
}
</script>

<style>
* {
  scrollbar-width: thin;
  scrollbar-color: #ffffff #FF9900;
}
*::-webkit-scrollbar{
    width: 10px;
}
*::-webkit-scrollbar-track{
    background-color: #FF9900;
    border-radius: 100vh;
}
*::-webkit-scrollbar-thumb{
    background: linear-gradient(transparent, #ffffff);
    border-radius: 100vh;
}
*::-webkit-scrollbar-thumb:hover{
    background: linear-gradient(transparent, #ffffff);
}
</style>
